import { ActionReducerMap } from '@ngrx/store';
import { ChatbotState, chatbotReducer } from '../components/chatbot/chatbot-state';

export interface AppState {
  chatbot: ChatbotState;
}

export const appReducer: ActionReducerMap<AppState> = {
  chatbot: chatbotReducer
};
